import { Either, Option } from 'funfix-core';
import { Record } from 'immutable';
import { FETCH_SCOPES_LOOKUP, RECEIVE_SCOPES_LOOKUP, RECEIVE_SCOPES_LOOKUP_ERROR } from '../actions/Scopes';
export const makeScopesState = Record({
  scopesLookup: Option.none()
});
export default function ScopesReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeScopesState();
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case FETCH_SCOPES_LOOKUP:
      return state.set('scopesLookup', Option.none());
    case RECEIVE_SCOPES_LOOKUP:
      return state.set('scopesLookup', Option.some(Either.right(action.scopesLookup)));
    case RECEIVE_SCOPES_LOOKUP_ERROR:
      return state.set('scopesLookup', Option.some(Either.left(action.dataErrorMessages)));
    default:
      // Flow compile-time validation that we've handled every action
      // prettier-ignore
      action;
      return state;
  }
}